import moment from 'moment';

/**
 * Calculate the start of the week for a given date and first day of week
 * @param {moment.Moment} date - The date to calculate from
 * @param {number} firstDayOfWeek - First day of week (0 = Sunday, 1 = Monday, etc.)
 * @returns {moment.Moment} - The start of the week
 */
export const getWeekStart = (date, firstDayOfWeek) => {
    const dayOfWeek = date.day(); // 0 = Sunday, 1 = Monday, etc.
    const daysToSubtract = (dayOfWeek - firstDayOfWeek + 7) % 7;
    return date.clone().subtract(daysToSubtract, 'days');
};

/**
 * Calculate the end of the week for a given date and first day of week
 * @param {moment.Moment} date - The date to calculate from
 * @param {number} firstDayOfWeek - First day of week (0 = Sunday, 1 = Monday, etc.)
 * @returns {moment.Moment} - The end of the week
 */
export const getWeekEnd = (date, firstDayOfWeek) => {
    const weekStart = getWeekStart(date, firstDayOfWeek);
    return weekStart.clone().add(6, 'days');
};

/**
 * Calculate the start and end of the week containing a month's start
 * @param {moment.Moment} monthDate - Any date within the target month
 * @param {number} firstDayOfWeek - First day of week (0 = Sunday, 1 = Monday, etc.)
 * @returns {object} - { startDate, endDate } in moment format
 */
export const getMonthWeekRange = (monthDate, firstDayOfWeek) => {
    const startOfMonth = moment.utc(monthDate).startOf('month');
    const endOfMonth = moment.utc(monthDate).endOf('month');
    
    return {
        startDate: getWeekStart(startOfMonth, firstDayOfWeek),
        endDate: getWeekEnd(endOfMonth, firstDayOfWeek)
    };
};

/**
 * Get the first day of week from session storage with fallback
 * @returns {number} - First day of week (0 = Sunday, 1 = Monday, etc.)
 */
export const getFirstDayOfWeek = () => {
    const sessionWeekStartDay = sessionStorage.getItem("WeekStartDay");
    const parsed = parseInt(sessionWeekStartDay);
    return !isNaN(parsed) ? parsed - 1 : 0; // default to Sunday (0) if null
};
